<template>
    <div class="widget-inner">
        <template v-if="isPersonalDashboardWidget">
            <div v-if="entries.length" v-for="entry in entries" :class="['margin-5', {'bottom-border': content.hasMore || entry !== entries[entries.length - 1 ]}]">
                <div class="flex flex-vertical-middle">
                    <router-link :to="'/task/entry/view/' + entry.id + '/' + entry.date"
                        :class="['flex full-width', {'text-danger': isPast(entry.date)}]">
                        <div class="text-overflow">
                            {{entry.title}}
                        </div>

                        <div class="flex--item-right no-wrap">
                            {{dateHelper('d.m.Y', entry.date)}}
                        </div>
                    </router-link>
                </div>
            </div>
            <div v-else class="widget-empty-message">
                <div :style="isPersonalDashboardWidget ? {color} : {}">
                    Es wurden keine Aufgaben für heute gefunden.
                </div>
            </div>

            <router-link v-if="content.hasMore" :to="widget.defaultRoute" class="flex margin-right-10 margin-bottom-3">
                <div class="text-overflow flex--item-right text-underline">
                    <span>Alle ansehen</span>
                    <i class="material-icons small-icon" role="img">open_in_new</i>
                </div>
            </router-link>
        </template>
        <template v-else>
            <div style="padding: 15px; text-align: center;">
                <router-link :to="'/task/entry/traced/tab-query/traced_expired'" title="Zu den überfälligen verfolgten Aufgaben"
                    style="color: #eb0000; font-weight: bold;">Überfällig: {{content.traced_expired ? content.traced_expired : 'Keine'}}
                </router-link>
                <br>
                <router-link :to="'/task/entry/traced/tab-query/traced_today'" title="Zu den heutigen verfolgten Aufgaben" style="color: green; font-weight: bold;">Heute:
                    {{content.traced_today ? content.traced_today : 'Keine'}}
                </router-link>
                <br>
                <br>
                <br>
                <router-link :to="{path: '/task/entry/traced'}" v-tooltip="'Zu den verfolgten Aufgaben'" class="button button-danger">Verfolgte Aufgaben</router-link>
            </div>
        </template>
    </div>
</template>
<script lang="ts">
    import {Component} from 'vue-facing-decorator';
    import {WidgetTask} from './WidgetTask.vue';

    @Component({
        name: 'WidgetTasktraced',
    })
    export default class WidgetTasktraced extends WidgetTask
    {
    };
</script>